<template>
  <div class="settings-footer">
    <div class="footer-actions">
      <v-btn
        class="btn-cancel"
        outlined
        @click="$emit('cancel')"
      >
        Cancel
      </v-btn>

      <v-btn
        class="btn-save"
        :disabled="disabled"
        @click="$emit('save')"
      >
        Save Changes
        <v-icon small class="ml-2">fa-regular fa-check</v-icon>
      </v-btn>
    </div>
  </div>
</template>



<script>
export default {
  name: "SettingsFooterActions",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>


<style lang="scss" scoped>
.settings-footer {
  position: sticky; /* se queda visible */
  bottom: 0;
  background: var(--v-background-base);
  padding: 16px 24px;
  z-index: 10;
}

.footer-actions {
  display: flex;
  justify-content: center; /* 👉 derecha */
  align-items: center;
  gap: 12px; /* espacio entre botones */
}

.btn-cancel {
  height: 40px;
  padding: 0 20px;
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
}

.btn-save {
  height: 40px;
  padding: 0 24px;
  border-radius: 8px;
  text-transform: none;
  font-weight: 600;
  background-color: var(--v-mainGreen-base) !important;
  color: white !important;

  &:disabled {
    background-color: #dcdcdc !important;
    color: #9a9a9a !important;
  }
}
</style>
